module.exports = __webpack_public_path__ + "img/shotsloading.06b1c350.svg";